import { JitsiLocalTrack } from 'lib-jitsi-meet'
import { handleActions } from 'redux-actions'

import * as screenSharingActions from '../actions/screenSharing'

export interface ScreenSharingState {
  isScreenSharing: boolean
  isScreenSharingInProgress: boolean
  screenSharingError: string
  systemAudioTrack: JitsiLocalTrack | null
  cameraMutedBeforeScreenSharing: boolean
}

const initialState: ScreenSharingState = {
  isScreenSharing: false,
  isScreenSharingInProgress: false,
  screenSharingError: '',
  systemAudioTrack: null,
  cameraMutedBeforeScreenSharing: true,
}

export default handleActions<ScreenSharingState, any>(
  {
    [screenSharingActions.toggleScreenSharing.toString()](state) {
      return { ...state, isScreenSharing: !state.isScreenSharing }
    },
    [screenSharingActions.setScreenSharingError.toString()](
      state,
      action: ReturnType<typeof screenSharingActions.setScreenSharingError>
    ) {
      return { ...state, screenSharingError: action.payload }
    },
    [screenSharingActions.setScreenSharingState.toString()](
      state,
      action: ReturnType<typeof screenSharingActions.setScreenSharingState>
    ) {
      return { ...state, isScreenSharingInProgress: action.payload }
    },
    [screenSharingActions.setSystemAudioTrack.toString()](
      state,
      action: ReturnType<typeof screenSharingActions.setSystemAudioTrack>
    ) {
      return { ...state, systemAudioTrack: action.payload }
    },
    [screenSharingActions.setIfCameraMutedBeforeScreenSharing.toString()](
      state,
      action: ReturnType<typeof screenSharingActions.setIfCameraMutedBeforeScreenSharing>
    ) {
      return { ...state, cameraMutedBeforeScreenSharing: action.payload }
    },
    [screenSharingActions.resetScreenSharingState.toString()]() {
      return initialState
    },
  },
  initialState
)
